import { render, staticRenderFns } from "./Scrum.vue?vue&type=template&id=ceca5f16&scoped=true&"
import script from "./Scrum.vue?vue&type=script&lang=js&"
export * from "./Scrum.vue?vue&type=script&lang=js&"
import style0 from "./Scrum.vue?vue&type=style&index=0&id=ceca5f16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceca5f16",
  null
  
)

export default component.exports